import {Component} from '@angular/core';
import {DialogRef} from "@progress/kendo-angular-dialog";

@Component({
  selector: 'app-modal-feedback-nfce',
  templateUrl: './modal-feedback-nfce.component.html',
  styleUrls: ['./modal-feedback-nfce.component.scss']
})
export class ModalFeedbackNfceComponent {
  titulo: string = '';
  subtitulo: string = '';
  mensagem: string = '';
  produto: string = '';
  listaPendencias: Array<{ tipo: 'erro' | 'aviso' | 'sucesso', titulo: string, descricao: string, icone?: string, classe?: string }> = [];
  tipo: 'sucesso' | 'erro' = 'erro';

  constructor(private dialogRef: DialogRef) {}

  fechar(): void {
    this.dialogRef.close();
  }

  get icone(): string {
    return this.tipo === 'sucesso' ? 'fa-check-circle' : 'fa-exclamation-triangle';
  }

  get tituloExibicao(): string {
    return this.corrijaTexto(this.titulo);
  }

  get subtituloExibicao(): string {
    return this.corrijaTexto(this.subtitulo);
  }

  get mensagemExibicao(): string {
    return this.corrijaTexto(this.mensagem);
  }

  get tituloBotao(): string {
    return this.tipo === 'sucesso' ? 'Fechar' : 'Entendi';
  }

  get produtoNormalizado(): string {
    return String(this.produto || '').trim();
  }

  get listaPendenciasNormalizada(): Array<{ tipo: string, titulo: string, descricao: string, icone: string, classe: string }> {
    return (this.listaPendencias || []).map((item: any) => {
      const tipo = item?.tipo || 'erro';
      return {
        tipo,
        titulo: this.corrijaTexto(item?.titulo || ''),
        descricao: this.corrijaTexto(item?.descricao || ''),
        icone: tipo === 'aviso' ? 'fa-info-circle' : (tipo === 'sucesso' ? 'fa-check-circle' : 'fa-times'),
        classe: `item-pendencia item-pendencia--${tipo}`
      };
    });
  }

  private corrijaTexto(texto: string): string {
    if (!texto) {
      return '';
    }

    return String(texto)
      .replace(/\bNao\b/g, 'Não')
      .replace(/\bnao\b/g, 'não')
      .replace(/NÃ£o/g, 'Não')
      .replace(/nÃ£o/g, 'não')
      .replace(/possivel/g, 'possível')
      .replace(/pendencias/g, 'pendências')
      .replace(/Pendencias/g, 'Pendências')
      .replace(/Emissao/g, 'Emissão')
      .replace(/emissao/g, 'emissão')
      .replace(/valido/g, 'válido')
      .replace(/validos/g, 'válidos')
      .replace(/invalido/g, 'inválido')
      .replace(/invalidos/g, 'inválidos')
      .replace(/codigo/g, 'código')
      .replace(/digitos/g, 'dígitos')
      .replace(/numericos/g, 'numéricos')
      .replace(/adicional escolhido emitido como item/g, 'adicional escolhido emitido como item')
      .replace(/fiscais validos/g, 'fiscais válidos')
      .replace(/possui dados fiscais validos/g, 'possui dados fiscais válidos')
      .replace(/Já/g, 'Já');
  }
}
